import React, { memo, FC } from 'react';
import { RichText } from '@marriott/mi-ui-library';
import { PointsCard } from '../PointsCard';
import { CardPointsListProps, PointsListItem } from './CardPointsList.types';
import { StyledCardPointsList } from './CardPointsList.styles';

/**
 * CardPointsList - Displays list of points earning opportunities
 *
 * Performance optimizations:
 * - Memoized component with React.memo
 * - Early return for empty data
 * - Stable keys for list items
 *
 * @param props - CardPointsListProps
 */
export const CardPointsList: FC<CardPointsListProps> = memo<CardPointsListProps>(
  ({ pointsHeader, pointsList, cardType, componentId }) => {
    // Early return if no data - prevents unnecessary rendering
    if (!pointsList?.length) {
      return null;
    }

    return (
      <StyledCardPointsList
        className="text-left"
        data-component-name="m-cobrand-CardPointsList"
        data-testid="cobrand-CardPointsList"
      >
        {/* Points header section */}
        {pointsHeader && (
          <RichText
            text={pointsHeader}
            componentId={`${componentId}-points-header`}
            customClass="text-left mb-3 mb-md-2 mt-2 mt-md-0"
          />
        )}

        {/* Points list - using index as key is acceptable here as list is static */}
        {pointsList.map((item: PointsListItem, index: number) => (
          <PointsCard
            key={`${componentId}-point-${index}`}
            isOnSpend={true}
            number={item.pointDetailsNoOfPoints}
            content={item.pointDetailsDescription}
            cardType={cardType}
            styleClass="mb-3 mb-lg-2"
            pointsForCarddetails={true}
          />
        ))}
      </StyledCardPointsList>
    );
  }
);

CardPointsList.displayName = 'CardPointsList';
